import React from 'react';
import { Coins } from '@phosphor-icons/react';
import { cn } from '../lib/utils';

interface CreditCostBadgeProps {
  cost: number;
  balance?: number; // If provided, shows red when insufficient
  className?: string;
  size?: 'sm' | 'md';
  showIcon?: boolean;
}

export function CreditCostBadge({ cost, balance, className, size = 'sm', showIcon = true }: CreditCostBadgeProps) {
  const insufficient = balance !== undefined && balance < cost;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-medium',
        size === 'sm' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs',
        insufficient
          ? 'bg-red-500/20 text-red-400'
          : 'bg-yellow-500/15 text-yellow-400',
        className
      )}
    >
      {showIcon && <Coins weight="fill" className={size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5'} />}
      {cost}
    </span>
  );
}
